<template>
    <div class="page_crud--edit">
        <div class="inner-wrap" v-if="api_ready">

            <el-form ref="form" class="form" :model="input">
                <div class="row" v-for="(row,index) in rows" :key="index">
                    <div class="field" v-for="(field,index) in row" :key="index">

                        <el-form-item v-model="input[field.key]"
                                      :class="typeof field.type == 'string' ? field.type : 'text'" :prop="field.key"
                                      :rules="defineRule(field.rules)" class="input-field">
                            <!-- <el-checkbox v-model="input[field.key]" v-if="field.type == 'boolean'" :label="$t(`field.${key}.${field.key}`)" true-label="1" false-label="0"/> -->
                            <div v-if="field.type == 'boolean'" class="control-group">
                                <div class="checkbox-group">
                                    <input :id="`${field.key}--${index}`" 
                                        @change="forceUpdate" v-model="input[field.key]" false-value="0" :disabled="disabledByColumn(field)"
                                           true-value="1" type="checkbox">
                                    <label :for="`${field.key}--${index}`" class="label">{{
                                            tran(key, field.key)
                                        }}</label>
                                </div>
                                <div v-if="error_fields.hasOwnProperty(field.key)" class="error-message">
                                    {{ getErrMsg(field.key) }}
                                </div>
                            </div>
                            <div v-else-if="field.type == 'select'" class="control-group">
                                <div class="label">{{ tran(key, field.key) }}</div>
                                <!-- <el-select v-model="input[field.key]" placeholder="Select" :remote="true" :key="options.hasOwnProperty(currentSetting.options[field.key].key) ? options[currentSetting.options[field.key].key].length : 0">
                                  <el-option
                                    v-for="item in options[currentSetting.options[field.key].key]"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                  </el-option>
                                </el-select> -->
<!--                              {{input}}-->
                                <select v-model="input[field.key]"
                                        @change="forceUpdate"
                                        :disabled="(field.hasOwnProperty('disabled') && field.disabled.includes('edit')) || disabledByColumn(field)">
                                    <option
                                            v-for="opt in currentSetting.options[field.key].values"
                                            v-if="currentSetting.options[field.key].values"
                                            :key="opt.key"
                                            :value="opt.value"
                                    >{{ $t(opt.key) }}
                                    </option>
                                    <option v-for="item in options[currentSetting.options[field.key].key]"
                                            :key="item.value" :value="item.value">{{ item.label }}
                                    </option>
                                </select>
                                <div v-if="error_fields.hasOwnProperty(field.key)" class="error-message">
                                    {{ getErrMsg(field.key) }}
                                </div>
                            </div>
                            <div v-else-if="field.type == 'sub-select'" class="control-group">
                              <div class="label">{{ tran(key, field.key) }}</div>
                              <select v-model="input[field.key]"
                                      @change="forceUpdate"
                                      :disabled="(field.hasOwnProperty('disabled') && field.disabled.includes('edit')) || disabledByColumn(field)">
                                <option
                                    v-for="opt in currentSetting.options[field.key].values"
                                    v-if="currentSetting.options[field.key].values"
                                    :key="opt.key"
                                    :value="opt.value">
                                  {{ $t(opt.key) }}
                                </option>
                                <option v-for="item in options[currentSetting.options[field.key].key]"
                                        :key="item.value" :value="item.value">
                                  {{ item.label }}
                                </option>
                              </select>
                              <div v-if="error_fields.hasOwnProperty(field.key)" class="error-message">
                                {{ getErrMsg(field.key) }}
                              </div>
                            </div>
                            <Component :is="field.component" v-else-if="field.type == 'component'" :key="componentsKey[field.key]"
                                       :ref="`component-${field.key}`" :currentSetting="currentSetting.cp_structure"
                                       :data="input" :field="field" :k="key" :action="'Edit'"/>
                            <div v-else-if="field.type == 'componentColumn'"
                                 :class="[{ 'error--field': errors.includes(field.key) }]" class="control-group">
                                <div class="label">{{ tran(key, field.key) }}</div>
                                <Component :is="field.component" :ref="`componentColumn-${field.key}`"
                                           v-model="input[field.key]" :action="'Edit'" :data="input" :field="field"
                                           :k="key" :options="options" :key="componentsKey[field.key]"/>
                                <div v-if="error_fields.hasOwnProperty(field.key)" class="error-message">
                                    {{ getErrMsg(field.key) }}
                                </div>
                            </div>


                            <div class="label-group" v-else-if="field.type == 'cpConnector'">
                                <label class="label" :for="field.key">{{ tran(key, field.key) }}</label>
                                <div v-if="input[field.key][index] !==undefined ">

                                <div class="abc" v-for="(row, index) in input[field.key]" :key="index">
                                    <label class="label" :for="field.key">編號 </label>
                                        <input v-model="input[field.key][index].connector_id" type = "text" disabled="true">
                                        <label class="label" :for="field.key"> 名稱 </label>
                                        <input v-model="input[field.key][index].name" type = "text" :disabled="disabled_by_column">
                                        <label class="label" :for="field.key"> 種類 </label>
                                        <select v-model="input[field.key][index].type" style="width:auto" :disabled="disabled_by_column">
                                            <option value="CCS2">CCS2</option>
                                            <option value="CHAdeMO">CHAdeMO</option>
                                        </select>
                                </div>
                                </div>
                            </div>


                            <!-- <div v-else-if="field.type == 'select'">{{  }}</div> -->
                            <div v-else :class="[{ 'error--field': errors.includes(field.key) }]" class="label-group">
                                <label :for="field.key" class="label">{{ tran(key, field.key) }}</label>
                                <textarea v-if="field.row && field.row > 1" v-model="input[field.key]" :disabled="(field.hasOwnProperty('disabled') && field.disabled.includes('edit')) || disabledByColumn(field)"
                                          rows="10"></textarea>
                                <input
                                        v-else
                                        v-model="input[field.key]"
                                        :disabled="(field.hasOwnProperty('disabled') && field.disabled.includes('edit')) || disabledByColumn(field)"
                                        :type="field.password ? 'password' : field.type == 'date' ? 'date' : field.type == 'time' ? 'time' : 'text'"
                                />
                                <div v-if="error_fields.hasOwnProperty(field.key)" class="error-message">
                                    {{ getErrMsg(field.key) }}
                                </div>
                                <!-- <el-input
                                  :rows="field.row ? field.row : 1"
                                  :type="field.row && field.row > 1 ? 'textarea' : ''"
                                  :label="field.key"
                                  :name="field.key"
                                  v-model="input[field.key]"
                                  :show-password="field.password"
                                /> -->
                            </div>

                        </el-form-item>

                    </div>
                </div>
            </el-form>
            <div class="action-btn">
                <el-button @click="go('')">{{ $t("button.back") }}</el-button>
                <el-button type="primary" @click="confirm">{{ $t("button.confirm") }}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    created() {
        this.key = "user_profile";
        Object.assign(this.currentSetting, this.$setting.crud[this.key]);
        // if(!this.permissions.includes(`EDIT_${this.currentSetting.key}`.toUpperCase())) {
        //   this.$router.push("/error/403");
        // }
    },
    async beforeMount() {
        this.currentSetting.fields = [...this.currentSetting.fields.filter(f => {
            if (f?.type == "action-btn") return false;
            if (f?.hidden?.includes("write")) return false;
            // privilege check
            if (f?.privilege) {
                console.log("privilege", f.privilege);
                let auth = true;
                f.privilege.map(p => {
                    if (!this.permissions.includes(p)) {
                        console.log("p: ", p);
                        auth = false;
                    }
                });
                console.log("auth: ", auth);
                return auth;
            }
            //
            if (typeof f.hidden == "undefined") return true;
            return true;
        })];

        if (this.currentSetting.structure) {
            this.rows = [];
            this.currentSetting.structure.map((row, i) => {
                this.rows[i] = [];
                row.map((field, j) => {
                    let current = this.currentSetting.fields.find(f => f.key == field);
                    if (current) {
                        this.rows[i].push(current);
                    }
                })
            });
        } else {
            this.rows = this.currentSetting.fields.map(field => {
                return [field];
            });
        }

        //option
        if (this.currentSetting.options) {
            await this.$axios.get(`options?id=${this.$route.params.id}&opts=${Object.keys(this.currentSetting.options).map(key => this.currentSetting.options[key].key).join("&opts=")}`, {
                params: {
                    // opts:
                }
            }).then(res => {
                let options = res.data.response.options;
                console.log("keys: ", Object.keys(options));

                Object.keys(this.currentSetting.options).filter(opt => options.hasOwnProperty(this.currentSetting.options[opt].key)).map(opt => {
                    console.log("opt: ", opt);
                    let key = this.currentSetting.options[opt].key;
                    this.options[key] = options[key].map(value => {
                        return {
                            label: typeof value == "object" ? value[this.currentSetting.options[opt].label] : value,
                            value: typeof value == "object" ? value[this.currentSetting.options[opt].value] : value,
                        }
                    });
                });
                return true;
            }).catch(err => {
                return false;
            });
        }
        //
        console.warn("settings: ", this.currentSetting?.api?.view);
        let data = (await this.$axios.get(`/user/profile`)).data;
        this.currentSetting.fields.map(field => {
            console.log(field);
            if (!(typeof field.protected == "boolean" && field.protected)) {
                if (data[field.key] != null && typeof data[field.key] == "object") {
                    console.log("cp1: ", field.key);
                    if (field.value) {
                        console.log("field.value: ", field.value);
                        console.log("cp2: ", field.key);
                        this.input[field.key] = this.getValueByField(data, field.value);
                    } else if(field.type == "cpConnector") {
                        this.input[field.key] = data[field.key] !== null ? data[field.key] : undefined;
                    }else {
                        console.log("cp3: ", field.key);
                        this.input[field.key] = data[this.currentSetting.id];
                    }
                } else if (field.type == "date") {
                    console.log("cp4: ", field.key);
                    this.input[field.key] = data.hasOwnProperty(field.key) && data[field.key] !== null ? this.$moment(`${data[field.key]}`).format("YYYY-MM-DD") : undefined;
                } else {
                    console.log("cp5: ", field.key);
                    this.input[field.key] = data.hasOwnProperty(field.key) && data[field.key] !== null ? `${data[field.key]}` : null;
                }
            }
            if(field?.type == 'component'||field?.type == 'componentColumn'){
              this.componentsKey[field.key]=1;
            }
        });
        console.log("this.disabled_by_column: ", this.currentSetting?.disabled_by_column);
        if(this.currentSetting?.disabled_by_column?.edit){
            this.disabled_by_column = true;
            var meet_the_conditions = this.currentSetting?.disabled_by_column?.edit.map(field => {
                if(field.type == "eq"){
                    if(data[field.key] == field.val){
                        return true;
                    }
                }
                this.disabled_by_column = false;
                return false;
            });
            console.log("meet_the_conditions: ", meet_the_conditions);
        }
        this.input[this.currentSetting.id] = data[this.currentSetting.id];
        this.api_ready = true;

    },
    methods: {
      // forceUpdate(){
      //   console.log(this.$refs);
      //   for(var i in this.$refs){
      //     if (i.indexOf('component-')>-1){
      //       $forceUpdate();
      //     }
      //     console.log(i)
      //   }
      //   // this.$refs
      //   this.$forceUpdate();
      // }

      forceUpdate(){
        console.log(this.componentsKey);
        for(var i in this.componentsKey){
          this.componentsKey[i]++;
        }
        this.$forceUpdate();
      },
        getErrMsg(field) {
            let label = this.tran(this.key, field)
            let msg = this.$te(`input_error.${this.error_fields[field]}`)
                ? this.$t(`input_error.${this.error_fields[field]}`)
                : this.error_fields[field];
            return `${label} ${msg}`;
        },
        async saveAllComponentData() {
            let success = true;
            console.log('hhi')
            await Promise.all(this.currentSetting.fields.filter(f => f.type == "component").map(async f => {

                if (!this.$refs.hasOwnProperty(`component-${f.key}`)) {
                    console.log(f.key + " not exits");
                    return;
                } else if (this.$refs[`component-${f.key}`].length > 0 && typeof this.$refs[`component-${f.key}`][0].save == "function") {
                    let result = this.$refs[`component-${f.key}`][0].save();
                    console.log(f.key + " save result: " + result)
                    return result;
                }

                return true;
            })).then(chks => {
                chks.map(chk => {
                    if (!chk) {
                        success = false;
                    }
                })
            });
            return success;
        },
        defineRule(rules) {
            let rule = {};
            if (Array.isArray(rules) && rules.includes("required") && !rules.includes("not-required-in-edit")) {
                rule = {
                    required: true
                };
            }
            return rule;
        },
        async confirm() {
            // display confirm dialog if enable in config
            if (this.currentSetting?.edit_confirm?.enable) {
                let confirm = await this.$confirm(this.$t(this.currentSetting?.edit_confirm?.message))
                    .then(() => {
                        return true;
                    })
                    .catch(() => {
                        return false;
                    });
                if (!confirm) return;
            }
            // if(!await this.saveAllComponentData()) return;
            let chk = await this.saveAllComponentData();
            console.log("confirm chk", chk);
            if (!chk) return;
            // if(await this.$refs.form.validate()) {
            console.log("ok: ", this.input);
            let loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            // let object = this.currentSetting.fields.filter(f=>f.hasOwnProperty("field")).map(f=>{
            //   this.input[f.key] = {
            //     id: this.input[f.key]
            //   }
            // });
            let valid = await this.$axios.put(`/user/profile`, {
                ...this.input,
            }).then(res => {
                return true;
            }).catch(err => {
                console.log(err?.response?.data);
                if (err?.response?.data?.errors) {
                    this.errors = err.response.data.errors;
                }
                if (err?.response?.data?.fields) {
                    this.error_fields = err.response.data.fields;
                }
                this.$message({
                    message: this.$t("error.generic"),
                    type: 'error'
                });
                return false;
            });
            loading.close();

            // only run if request success
            if (valid) {
                location.reload();
            }

            // }else {
            //   console.warn("wrong");
            // }
        },
        disabledByColumn(field){
            if(field.disabled_by_column != undefined && field.disabled_by_column == true && this.disabled_by_column == true){
                return true;
            }
            return false;
        },
        fieldUpdate(field, value) {
            console.log(field, ": ", value);
            this.input[field] = value;
            this.force_update = new Date().getTime();
            this.$forceUpdate();
        },
        getValueByField(row, field) {
            // if(Array.isArray())
            console.log("fields: ", field);
            let split = field.split(".");
            let value = row;
            // if(split.length > 0) split.unshift(field.key);
            split.map(f => {
                console.log("field: ", f);
                if (typeof value != "object") return;
                if (Array.isArray(value[f]) && split.length >= 2) {
                    let list = value[f];
                    value = list.map(arr => arr[split[1]]).join(", ");

                } else {
                    value = value.hasOwnProperty(f) ? value[f] : "";
                }
            });
            return value;
        },
    },
    computed: {
        ...mapState({
            permissions: state => state.user.user_info.permissions
        }),
    },
    data() {
        return {
            key: "",
            errors: [],
            error_fields: {},
            options: {},
            currentSetting: {},
            api_ready: false,
            rows: [],
            input: {},
            componentsKey:{},
            force_update: 0,
            disabled_by_column:false
        }
    }
}
</script>

<style lang="scss" scoped>
.page_crud--edit {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;

  .inner-wrap {
    height: 100%;
    width: 95%;
    max-width: 800px;
    display: flex;
    flex-direction: column;
    padding: 20px 0;

    .form {
      flex-grow: 1;

      & > .row {
        display: flex;
        width: 100%;
        max-width: 100%;

        & > .field {
          flex: 1;
          // width: 100%;
          max-width: 100%;

          & > :first-child {
            margin-right: 5px;
          }

          &:not(:first-child) {
            margin-left: 5px;
          }
        }
      }

      .checkbox-group {
        display: flex;
        align-items: center;
      }

      .label-group,
      .control-group {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .label {
          // width: 150px;
          // min-width: 150px;
        }

        input:not([type="checkbox"]) {
          height: 30px;
          // width: 100%;
        }

        textarea {
          width: 100%;
        }

        .error-message {
          font-size: small;
          color: red;
          line-height: 1.5em;
        }
      }

      .el-form-item {
        margin-bottom: 10px;

        .el-select {
          width: 100%;
        }

        select {
          height: 40px;
          line-height: 40px;
          width: 100%;
        }
      }

      .field {
        &:not(:last-child) {
          // margin-bottom: 10px;
        }
      }

      .error--field {
        .label {
          color: red;
        }

        input {
          border: 1.5px solid red;

          &:focus {
            outline: red auto 1px;
            border: 1.5px solid red !important;
          }
        }
      }
    }

    .action-btn {
      display: flex;
      justify-content: space-between;
      padding: 20px 0;
    }
  }
}
</style>